import React, { useState, useEffect } from "react";
import { BASE_CRM_URL } from "../../feature-module/components/config/config";
import Select from "react-select";
import PropTypes from "prop-types";
import { propTypes } from "react-bootstrap/esm/Image";
const EditProducttable = ({
  currencyId,
  CurrencyName,
  discount_type,
  initialDiscount,
  discount_type_id,
  initialDiscountPercent,
  initialDiscountTotal,
  initialItems = [],
  adjustment,
  onProductDataChange,
}) => {
  const [items, setItems] = useState(initialItems);

  console.log(currencyId, "currencyid");
  console.log(CurrencyName, "CurrencyName");
  console.log(discount_type, "discounttype");
  console.log(initialDiscount, "initialdiscount");
  console.log(discount_type_id, "discount_type_id");
  console.log(initialDiscountPercent, "initialDiscountPercent");
  console.log(initialDiscountTotal, "initialDiscountTotal");

  console.log(initialItems, "bchsbkjjhxsbchjbchbhxcbhbchjbc");

  const [itemOptions, setItemOptions] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  const [discountType, setDiscountType] = useState("before");

  const [discountMethod, setDiscountMethod] = useState(
    Number(initialDiscountPercent || 0) > 0 ? "%" : "fixed",
  );

  const [discount, setDiscount] = useState(
    Number(initialDiscountPercent || 0) > 0
      ? Number(initialDiscountPercent)
      : Number(initialDiscountTotal || 0),
  );

  const [quantityOption, setQuantityOption] = useState("Qty");

  const [taxOptions, setTaxOptions] = useState([]);

  const [currencies, setCurrencies] = useState([]);
  console.log(currencies, "cureenciewssssssssssssssssssssssss");
  const [currencyLoading, setCurrencyLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const [discountOptions, setDiscountOptions] = useState([]);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);

  const [taxesInitialized, setTaxesInitialized] = useState(false);

  const [adjustmentValue, setAdjustmentValue] = useState(adjustment ?? 0);

  const getProducts = async () => {
    try {
      setItemLoading(true);

      const response = await fetch(`${BASE_CRM_URL}products/GetProducts`);
      const data = await response.json();

      if (data.Status) {
        const products = data.Data.map((item) => ({
          id: item.id, // product id
          item: item.description,
          description: item.long_description || item.description,
          hsn: item.HSNCode || "", // always use "hsn"
          qty: 1,
          rate: parseFloat(item.price || 0),
          amount: parseFloat(item.price || 0),
          unit: item.unit,
          tax1: Number(item.tax1) || 0,
          tax2: Number(item.tax2) || 0,
        }));

        setItemOptions(products);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setItemLoading(false);
    }
  };
  currencies;
  const getCurrencies = async () => {
    try {
      setCurrencyLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCurrencies`);
      const data = await response.json();

      if (data.Status) {
        const options = data.Data.map((item) => ({
          value: Number(item.id),
          label: item.name,
          name: item.name,
          symbol: item.symbol,
        }));

        setCurrencies(options);
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const getTaxes = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate),
        }));

        setTaxOptions(options);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }
  };

  const getDiscountTypes = async () => {
    try {
      setDiscountLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetDescountTypes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.TaxType,
        }));

        setDiscountOptions(options);
      }
    } catch (error) {
      console.error("Error fetching discount types:", error);
    } finally {
      setDiscountLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
    getTaxes();
    getDiscountTypes();
    getCurrencies();
  }, []);

  useEffect(() => {
    const percent = Number(initialDiscountPercent || 0);
    const fixed = Number(initialDiscountTotal || 0);

    if (percent > 0) {
      // Backend has percentage discount
      setDiscountMethod("%");
      setDiscount(percent);
    } else {
      // Backend has fixed/amount discount
      setDiscountMethod("fixed");
      setDiscount(fixed);
    }
  }, [initialDiscountPercent, initialDiscountTotal]);

  useEffect(() => {
    if (!discountOptions.length) return;

    console.log("discount_type from parent:", discount_type);
    console.log("discount_type_id from parent:", discount_type_id);
    console.log("discountOptions:", discountOptions);

    const selectedOption = discountOptions.find(
      (option) => Number(option.value) === Number(discount_type_id),
    );

    console.log("Selected discount option:", selectedOption);

    if (selectedOption) {
      setSelectedDiscountType(selectedOption);

      setDiscountType(Number(selectedOption.value) === 1 ? "after" : "before");
    }
  }, [discountOptions, discount_type, discount_type_id]);

  useEffect(() => {
    if (!currencies.length) return;

    const selectedOption = currencies.find(
      (option) => Number(option.value) === Number(currencyId),
    );

    console.log("Currency from proposal:", currencyId);
    console.log("Currency options:", currencies);
    console.log("Matched currency:", selectedOption);

    setSelectedCurrency(selectedOption);
  }, [currencyId, currencies, CurrencyName]);

  const addItem = (item) => {
    const newItem = {
      ...item,
      // unique key for React – must come AFTER the spread
      id: `row-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      productId: item.id || item.productId, // keep the real product id
      selectedTaxes: item.selectedTaxes || [],
      taxes: item.selectedTaxes || [],
      hsn: item.hsn || item.HSNCode || "",
      isSaved: false,
    };

    setItems((prev) => [...prev, newItem]);
  };
  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const saveItem = (id) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;

        return {
          ...item,
          taxes: item.selectedTaxes,
          isSaved: true,
        };
      }),
    );
  };
  const editItem = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              isSaved: false,
            }
          : item,
      ),
    );
  };

  const calculateSubtotal = () => {
    return items.reduce((sum, item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      return sum + qty * Number(item.rate || 0);
    }, 0);
  };

  const subtotal = calculateSubtotal();

  // ------------------------------------
  // Calculate TAX
  // ------------------------------------
  const calculateTaxes = (applyBeforeTaxDiscount = true) => {
    const taxSummary = {};

    items.forEach((item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      const amount = qty * Number(item.rate || 0);

      let taxableAmount = amount;

      // Apply discount BEFORE TAX
      if (
        applyBeforeTaxDiscount &&
        discountType === "before" &&
        Number(discount || 0) > 0
      ) {
        let itemDiscount = 0;

        if (discountMethod === "%" || discountMethod === "percentage") {
          itemDiscount = (amount * Number(discount || 0)) / 100;
        } else {
          // Fixed discount distributed proportionally
          itemDiscount =
            subtotal > 0 ? (Number(discount || 0) * amount) / subtotal : 0;
        }

        taxableAmount = Math.max(0, amount - itemDiscount);
      }

      const selectedTaxes = item.selectedTaxes || item.taxes || [];

      selectedTaxes.forEach((tax) => {
        const taxRate = Number(tax.taxrate || 0);

        const taxAmount = (taxableAmount * taxRate) / 100;

        if (!taxSummary[tax.value]) {
          taxSummary[tax.value] = {
            value: tax.value,
            name: tax.label,
            taxrate: taxRate,
            amount: 0,
          };
        }

        taxSummary[tax.value].amount += taxAmount;
      });
    });

    return Object.values(taxSummary);
  };

  // ------------------------------------
  // Base Tax
  // ------------------------------------
  // For AFTER TAX discount, tax must be
  // calculated without discount first.
  const baseTaxes = calculateTaxes(false);

  const baseTotalTax = baseTaxes.reduce(
    (sum, tax) => sum + Number(tax.amount || 0),
    0,
  );

  // ------------------------------------
  // Calculate Discount
  // ------------------------------------
  const calculateDiscountAmount = () => {
    const discountValue = Number(discount || 0);

    if (discountValue <= 0) {
      return 0;
    }

    // Fixed / Rupee discount
    if (discountMethod === "fixed" || discountMethod === "rs") {
      return Math.min(discountValue, subtotal);
    }

    // Percentage discount BEFORE TAX
    if (discountType === "before") {
      return (subtotal * discountValue) / 100;
    }

    // Percentage discount AFTER TAX
    return ((subtotal + baseTotalTax) * discountValue) / 100;
  };

  const discountAmount = calculateDiscountAmount();

  // ------------------------------------
  // Final Taxes
  // ------------------------------------
  const taxes = calculateTaxes(true);

  const totalTax = taxes.reduce((sum, tax) => sum + Number(tax.amount || 0), 0);

  // ------------------------------------
  // Total
  // ------------------------------------
  const calculateTotal = () => {
    if (discountType === "before") {
      return (
        subtotal - discountAmount + totalTax + Number(adjustmentValue || 0)
      );
    }

    return subtotal + totalTax - discountAmount + Number(adjustmentValue || 0);
  };

  const total = calculateTotal();

  useEffect(() => {
    if (taxesInitialized) return;
    if (!initialItems?.length || !taxOptions.length) return;

    const updatedItems = initialItems.map((item, index) => {
      const selectedTaxes = (item.taxes || [])
        .map((existingTax) => {
          return taxOptions.find(
            (taxOption) =>
              taxOption.label === existingTax.taxname ||
              Number(taxOption.taxrate) === Number(existingTax.taxrate),
          );
        })
        .filter(Boolean);

      return {
        ...item,
        id: item.id ?? `existing-${item.productId}-${index}`,
        selectedTaxes,
        taxes: selectedTaxes,
        isSaved: true,
      };
    });

    setItems(updatedItems);
    setTaxesInitialized(true);
  }, [initialItems, taxOptions, taxesInitialized]);

  useEffect(() => {
    setAdjustmentValue(adjustment ?? 0);
  }, [adjustment]);

  // useEffect(() => {
  //   if (!onProductDataChange) return;

  //   const isPercentageDiscount = discountMethod === "%";
  //   const isFixedDiscount =
  //     discountMethod === "fixed" || discountMethod === "rs";

  //   onProductDataChange({
  //     items,
  //     subtotal,

  //     // User-entered discount value
  //     discount: Number(discount || 0),

  //     // IMPORTANT:
  //     // % selected  -> send percentage
  //     // Rs selected -> always send 0
  //     discount_percent: isPercentageDiscount ? Number(discount || 0) : 0,

  //     // IMPORTANT:
  //     // % selected -> calculated discount amount
  //     // Rs selected -> entered fixed amount
  //     discount_total: isFixedDiscount
  //       ? Number(discount || 0)
  //       : Number(discountAmount || 0),

  //     discountAmount,

  //     discountType: selectedDiscountType?.label || "",
  //     discountTypeId: selectedDiscountType?.value ?? discount_type_id ?? null,

  //     discountMethod,

  //     taxes,
  //     totalTax,
  //     adjustment: Number(adjustmentValue || 0),
  //     total,

  //     currencyId: selectedCurrency?.value || currencyId || null,
  //     currencyName: selectedCurrency?.name || null,
  //     currencySymbol: selectedCurrency?.symbol || null,
  //   });
  // }, [
  //   items,
  //   discount,
  //   discountAmount,
  //   discountType,
  //   selectedDiscountType,
  //   taxes,
  //   totalTax,
  //   adjustment,
  //   total,
  //   currencyId,
  //   discount_type_id,
  //   onProductDataChange,
  // ]);

  useEffect(() => {
    if (!onProductDataChange) return;

    const isPercentageDiscount = discountMethod === "%";
    const isFixedDiscount =
      discountMethod === "fixed" || discountMethod === "rs";

    onProductDataChange({
      items,
      subtotal,
      discount: Number(discount || 0),
      discount_percent: isPercentageDiscount ? Number(discount || 0) : 0,
      discount_total: isFixedDiscount
        ? Number(discount || 0)
        : Number(discountAmount || 0),
      discountAmount,
      discountType: selectedDiscountType?.label || "",
      discountTypeId: selectedDiscountType?.value ?? discount_type_id ?? null,
      discountMethod,
      taxes,
      totalTax,
      adjustment: Number(adjustmentValue || 0),
      total,
      currencyId: selectedCurrency?.value || currencyId || null,
      currencyName: selectedCurrency?.name || null,
      currencySymbol: selectedCurrency?.symbol || null,
    });
  }, [
    items,
    discount,
    discountMethod,
    discountType,
    selectedDiscountType,
    selectedCurrency,
    adjustmentValue,
    // do NOT put: discountAmount, taxes, totalTax, total, onProductDataChange
    // they are either derived or unstable
  ]);
  return (
    <div className="row">
      <div className="col-4 mb-3">
        <Select
          options={itemOptions.map((option) => ({
            value: option.id,
            label: option.item,
            ...option, // include all properties
          }))}
          isLoading={itemLoading}
          placeholder="Select Item"
          // onChange={(selectedOption) => {
          //   if (!selectedOption) return;

          //   addItem({
          //     item: selectedOption.item,
          //     description: selectedOption.description,
          //     hsn: selectedOption.HSNCode,
          //     qty: selectedOption.qty,
          //     rate: selectedOption.rate,
          //     amount: selectedOption.amount,
          //     unit: selectedOption.unit,
          //     productId: selectedOption.id,
          //     tax: selectedOption.tax,

          //     selectedTaxes: taxOptions.filter(
          //       (tax) =>
          //         Number(tax.value) === Number(selectedOption.tax) ||
          //         Number(tax.value) === Number(selectedOption.tax2),
          //     ),
          //   });
          // }}
          onChange={(selectedOption) => {
            if (!selectedOption) return;

            const tax1Option = taxOptions.find(
              (tax) => Number(tax.value) === Number(selectedOption.tax1),
            );

            const tax2Option = taxOptions.find(
              (tax) => Number(tax.value) === Number(selectedOption.tax2),
            );

            const selectedTaxes = [tax1Option, tax2Option].filter(Boolean);

            addItem({
              item: selectedOption.item,
              description: selectedOption.description,

              hsn: selectedOption.hsn,

              qty: selectedOption.qty || 1,
              rate: Number(selectedOption.rate || 0),
              amount: Number(selectedOption.amount || 0),

              unit: selectedOption.unit,

              productId: selectedOption.id,

              tax1: selectedOption.tax1,
              tax2: selectedOption.tax2,

              selectedTaxes,
              taxes: selectedTaxes,
            });
          }}
        />
      </div>

      {/* Radio buttons to switch quantity display */}
      <div className="d-flex justify-content-end col-4 d-none">
        <fieldset>
          <label>
            <b>Show quantity as:</b>
          </label>
          <div className="form-check ms-2 form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="qty"
              value="Qty"
              checked={quantityOption === "Qty"}
              onChange={() => setQuantityOption("Qty")}
            />
            <label className="form-check-label" htmlFor="qty">
              Qty
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="hours"
              value="Hours"
              checked={quantityOption === "Hours"}
              onChange={() => setQuantityOption("Hours")}
            />
            <label className="form-check-label" htmlFor="hours">
              Hours
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="qtyHours"
              value="Qty/Hours"
              checked={quantityOption === "Qty/Hours"}
              onChange={() => setQuantityOption("Qty/Hours")}
            />
            <label className="form-check-label" htmlFor="qtyHours">
              Qty/Hours
            </label>
          </div>
        </fieldset>
      </div>

      <div className="d-flex justify-content-end gap-3 col-8">
        <div className="col-3">
          <Select
            options={currencies}
            value={selectedCurrency}
            isLoading={currencyLoading}
            placeholder="Select Currency"
            onChange={(option) => {
              setSelectedCurrency(option);
            }}
          />
        </div>

        <div className="col-3">
          <Select
            options={discountOptions}
            value={selectedDiscountType}
            isLoading={discountLoading}
            placeholder="Select Discount"
            onChange={(option) => {
              setSelectedDiscountType(option);

              setDiscountType(Number(option?.value) === 1 ? "after" : "before");
            }}
          />
        </div>
      </div>

      {/* Table to display items */}
      <div className="table-responsive mt-2">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Item</th>
              <th>Description</th>
              <th>HSN</th>
              <th>
                {quantityOption === "Qty" && "Qty"}
                {quantityOption === "Hours" && "Hours"}
                {quantityOption === "Qty/Hours" && "Qty/Hours"}
              </th>
              <th>Rate</th>
              <th>Tax</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center">
                  No data available
                </td>
              </tr>
            ) : (
              items.map((item) => {
                const quantity =
                  quantityOption === "Hours" ? item.hours : item.qty;
                const total = (quantity || 0) * (item.rate || 0);
                // const taxAmount = (total * parseFloat(item.tax)) / 100;
                const taxAmount = (total * Number(item.taxRate || 0)) / 100;

                const rowTotal = total + taxAmount;

                return (
                  <tr key={item.id}>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={item.item}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={item.description}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={item.isSaved}
                        readOnly
                        className="form-control"
                        value={item.hsn || ""}
                        onChange={(e) =>
                          setItems(
                            items.map((i) =>
                              i.id === item.id
                                ? { ...i, hsn: e.target.value }
                                : i,
                            ),
                          )
                        }
                      />
                    </td>
                    <td>
                      {quantityOption === "Qty" ||
                      quantityOption === "Qty/Hours" ? (
                        <input
                          type="number"
                          disabled={item.isSaved}
                          className="form-control"
                          value={item.qty}
                          onChange={(e) =>
                            setItems(
                              items.map((i) =>
                                i.id === item.id
                                  ? { ...i, qty: e.target.value }
                                  : i,
                              ),
                            )
                          }
                        />
                      ) : quantityOption === "Hours" ? (
                        <input
                          type="number"
                          className="form-control"
                          value={item.hours}
                          onChange={(e) =>
                            setItems(
                              items.map((i) =>
                                i.id === item.id
                                  ? { ...i, hours: e.target.value }
                                  : i,
                              ),
                            )
                          }
                        />
                      ) : null}
                    </td>
                    <td>
                      <input
                        type="number"
                        disabled={item.isSaved}
                        className="form-control"
                        value={item.rate}
                        onChange={(e) =>
                          setItems(
                            items.map((i) =>
                              i.id === item.id
                                ? { ...i, rate: e.target.value }
                                : i,
                            ),
                          )
                        }
                      />
                    </td>
                    <td>
                      {" "}
                      {item.isSaved ? (
                        <div className="d-flex flex-wrap gap-1">
                          {" "}
                          {item.taxes.map((tax) => (
                            <span key={tax.value} className="badge bg-success">
                              {" "}
                              {tax.label}{" "}
                            </span>
                          ))}{" "}
                        </div>
                      ) : (
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={taxOptions}
                          value={item.selectedTaxes}
                          placeholder="Select Tax"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            valueContainer: (base) => ({
                              ...base,
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              scrollbarWidth: "none",
                            }),
                            multiValue: (base) => ({
                              ...base,
                              minWidth: "fit-content",
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          onChange={(value) => {
                            setItems((prev) =>
                              prev.map((row) =>
                                row.id === item.id
                                  ? { ...row, selectedTaxes: value || [] }
                                  : row,
                              ),
                            );
                          }}
                        />
                      )}{" "}
                    </td>
                    <td>{rowTotal.toFixed(2)}</td> {/* Row total */}
                    <td>
                      {item.isSaved ? (
                        <button
                          type="button"
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => editItem(item.id)}
                        >
                          <i className="fa-solid fa-pen"></i>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success btn-sm me-2"
                          onClick={() => saveItem(item.id)}
                        >
                          <i className="fa-solid fa-check"></i>
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteItem(item.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Subtotal, Discount, IGST, and Total */}
      <div className="row mt-3">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Sub Total:</span>
              <span>Rs.{calculateSubtotal().toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between align-items-center gap-2">
              <span>Discount:</span>
              <div className="d-flex gap-1 " style={{ width: "50%" }}>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "80px" }}
                  value={discountMethod}
                  onChange={(e) => {
                    const method = e.target.value;

                    setDiscountMethod(method);
                    setDiscount(0);
                  }}
                >
                  <option value="%">%</option>
                  <option value="fixed">Rs.</option>
                </select>

                <input
                  type="number"
                  step="any"
                  className="form-control form-control-sm"
                  placeholder={discountMethod === "%" ? "Enter %" : "Enter Rs."}
                  min="0"
                  max={discountMethod === "%" ? "100" : undefined}
                  value={discount || ""}
                  onChange={(e) => {
                    let val = Number(e.target.value);

                    if (val < 0) {
                      val = 0;
                    }

                    if (discountMethod === "%" && val > 100) {
                      val = 100;
                    }

                    setDiscount(val);
                  }}
                />
              </div>
              <span>-Rs. {discountAmount.toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Total Tax:</span>
              <span>Rs. {totalTax.toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Adjustment:</span>

              <div style={{ width: "30%" }}>
                <input
                  type="number"
                  className="form-control ms-1"
                  value={adjustmentValue}
                  onChange={(e) =>
                    setAdjustmentValue(
                      e.target.value === "" ? 0 : parseFloat(e.target.value),
                    )
                  }
                />
              </div>

              <span>Rs.{Number(adjustmentValue || 0).toFixed(2)}</span>
            </div>

            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-end">
              <strong>Total:</strong>
              <strong> Rs.{calculateTotal().toFixed(2)}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EditProducttable.propTypes = {
  currencyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  CurrencyName: PropTypes.string,

  discount_type: PropTypes.string,
  discount_type_id: PropTypes.number,

  initialDiscountPercent: propTypes.number,
  initialDiscountTotal: propTypes.number,

  initialDiscount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  initialItems: PropTypes.array,
  adjustment: PropTypes.number,

  onProductDataChange: PropTypes.func,
};

export default EditProducttable;
